var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Ai-Edit-Spark--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Ai Edit Spark Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ai-edit-spark--change-edit-modify-pencil-write-writing-artificial-intelligence-ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.92572 13.2018 -3 0.26 0.26 -3 6.23998 -6.19999c0.0932 -0.09524 0.2044 -0.17092 0.3272 -0.22259 0.1227 -0.05167 0.2546 -0.07828 0.3878 -0.07828 0.1332 0 0.2651 0.02661 0.3879 0.07828 0.1228 0.05167 0.234 0.12735 0.3271 0.22259l1.27 1.28c0.0937 0.09297 0.1681 0.20357 0.2189 0.32543 0.0508 0.12186 0.0769 0.25256 0.0769 0.38457 0 0.13201 -0.0261 0.26272 -0.0769 0.38458 -0.0508 0.12186 -0.1252 0.23246 -0.2189 0.32542L6.92572 13.2018Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2136",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.841689 3.97204c-0.35093 -0.06106 -0.35093 -0.56483 -0.000001 -0.62588C2.11305 3.12497 3.12423 2.15661 3.40019 0.896007l0.02115 -0.096629c0.07592 -0.346833 0.56977 -0.348992 0.64872 -0.002836l0.02568 0.11261C4.38191 2.16381 5.39337 3.12399 6.6612 3.34456c0.35272 0.06136 0.35272 0.56771 0 0.62907 -1.26783 0.22057 -2.27929 1.18075 -2.56546 2.43541l-0.02568 0.11261c-0.07895 0.34616 -0.5728 0.344 -0.64872 -0.00284l-0.02115 -0.09662C3.12423 5.16158 2.11305 4.19322 0.841689 3.97204Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEditIcon);
export default __webpack_public_path__ + "static/media/ai-edit-icon.5424daf71f49f975bd2d04b84e4d08fa.svg";
export { ForwardRef as ReactComponent };